export const TIKTOK_IMAGE_SIZE_SPEC = {
  width: 385,
  height: 764,
  pictureWidth: 385,
  minHeight: 684,
  maxHeight: 684
};
